export default __webpack_public_path__ + "static/media/sip-error-icon.3eec3303.svg";